import { UserLightGlyph } from '@acast/decibel-glyphs';
import T from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import impersonateUser from 'shared/components/admin-tools/impersonate-user';
import config from '../../../app/config';
import { permissionsPropType, profilePropType } from '../../../customPropTypes';
import {
  selectHasRole,
  selectUserData,
  selectUserPermissions,
  selectUserPermissionsV2,
} from '../../../ducks/user';
import {
  getUserExpires,
  getUserId,
  getUserToken,
  isAuth0User,
  isUserBeingImpersonated,
  restoreImpersonator,
} from '../../../services/authentication';
import TopNavigationBar from './TopNavigationBar';

const getEncodedSession = ({ token, expires, userId, email, auth0UserId, isAuth0 }) => {
  return window.btoa(JSON.stringify({ token, expires, userId, email, auth0UserId, isAuth0 }));
};

const getUserMenuItems = ({ isAdmin }) => {
  const menuItems = [];

  if (isUserBeingImpersonated()) {
    menuItems.push({
      label: 'Stop impersonating',
      onClick: restoreImpersonator,
      glyph: UserLightGlyph,
    });
  } else if (isAdmin) {
    menuItems.push({
      label: 'Impersonate user',
      onClick: impersonateUser,
      glyph: UserLightGlyph,
    });
  }

  return menuItems;
};

const MainNavigation = ({
  permissions,
  permissionsV2,
  profile,
  token,
  isAdmin,
  expires,
  auth0UserId,
  isAuth0,
}) => {
  const { user: userId, roles, email, avatar } = profile;

  return (
    <TopNavigationBar
      selected="create"
      dashboardUrl={config.get('DASHBOARD_APP_URL')}
      createUrl="/"
      insightsUrl={config.get('INSIGHTS_HOST')}
      financeUrl={config.get('FINANCE_DASHBOARD_HOST')}
      profileAppUrl={config.get('PROFILE_APP_URL')}
      privacyPolicyUrl={config.get('PRIVACY_POLICY_URL')}
      userImageUrl={avatar}
      logoutUrl="/logout"
      token={token}
      roles={roles}
      permissions={permissions}
      isAuth0={isAuth0}
      encodedSession={getEncodedSession({ token, expires, userId, email, auth0UserId, isAuth0 })}
      customUserMenuLinks={getUserMenuItems({ isAdmin })}
      rolesApiPermissions={permissionsV2}
    />
  );
};

MainNavigation.propTypes = {
  permissions: permissionsPropType,
  profile: profilePropType,
  isAdmin: T.bool,
};

export default connect(state => ({
  permissions: selectUserPermissions(state),
  permissionsV2: selectUserPermissionsV2(state),
  profile: selectUserData(state),
  isAdmin: selectHasRole('admin')(state),
  token: getUserToken(state),
  auth0UserId: getUserId(state),
  expires: getUserExpires(state),
  isAuth0: isAuth0User(state),
}))(MainNavigation);
